import Vue from 'vue'
import apiClient from '@/services/axios'

export function getRoutingStatistics(options) {
  return apiClient.post('/analytics/routing-statistics', options)
}

export function getMapboxStatistics(options) {
  return apiClient.get('/analytics/mapbox-statistics', {
    params: options,
  })
}

export function getStudentStatistics(options) {
  return apiClient.get('/analytics/student-statistics', {
    params: options,
  })
}

export function getVehicleStatistics(options) {
  return apiClient.get('/analytics/vehicle-statistics', {
    params: options,
  })
}

export function getFuelPricesStatistics(options) {
  return apiClient.get('/analytics/fuel-prices-statistics', {
    params: options,
  })
}

export function getAttendanceStatistics(options) {
  return apiClient.get('/analytics/attendance-statistics', {
    params: options,
  })
}

export function saveMapboxUsageStatistic(statistic) {
  // Fire-and-forget usage telemetry, called from ~90 places without a .catch().
  // A backend 4xx here must never become an unhandled rejection: in dev that
  // throws the webpack error overlay over the whole app, which then swallows
  // every click and keystroke until the page is refreshed.
  return apiClient.post('/analytics/mapbox-statistic', statistic).catch(() => null)
}
